import axios from "axios";
import {
  checkStatus,
  getHeaders,
} from "../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseTicketURL = process.env.REACT_APP_BASE_URL_TICKET;
const baseURL = process.env.REACT_APP_BASE_URL;

export async function addTicket(params) {
  try {
    const response = await axiosInstance.post(
      `${baseTicketURL}/Lead/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Get Lead  List  Data.
export async function getTicketListData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseTicketURL}/Lead/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For fetching Get Observers List Service.

export async function getObserversList(params) {
  try {
    const response = await axiosInstance.get(
      `${baseTicketURL}/Lead/ObserverList?observerName=${params.observerName}`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Delete Lead...
export const deleteTicketListData = async (params) => {
  try {
    const response = await axios.delete(
      `${baseTicketURL}/Lead/DeleteTicket`,
      {
        headers: await getHeaders(),
        params: {
          id: params.id,
        },
        deleteTicketAttachmentData,
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

//For Add Observers.
export async function addObserver(params) {
  try {
    const response = await axiosInstance.post(
      `${baseTicketURL}/Lead/Observer/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Update My Lead List Status ...
export const updateMyTicketListData = async (params) => {
  try {
    const response = await axios.put(
      `${baseTicketURL}/Lead/UpdateTicketStatus`,
      null,
        {
        headers: await getHeaders(),
        params: {
          ticketId: params.ticketId,
          ticketStatus: params.ticketStatus,
        },
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// For Master Data.

export async function GetMasterCategaryData(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Employee/GetMasterData?categoryId=${params.categoryId}`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Delete Lead...
export const deleteTicketObserverListData = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseTicketURL}/Lead/Observer/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

//For Add Attachment ...
export const addTicketAttachmentData = async (params) => {
  try {
    const response = await axiosInstance.post(
      `${baseTicketURL}/Lead/Attachment/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

//For Delete Attachment ...

export async function deleteTicketAttachmentData(params) {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/Attachment/Delete`,
      {
        headers: await getHeaders(),
        data: params,
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// Get EmployeeRequestCategory....


  export const getEmployeeRequestCategory = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/EmployeeRequest/Category/List`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }
  


  // Add/Edit EmployeeRequestCategory....

  export const addEmployeeRequestCategory = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/Category/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  // delete EmployeeRequestCategory..

  export const deleteEmployeeRequestCategory = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/Category/Delete`,
      {
        headers: await getHeaders(),
        data: params 
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


 // Get EmployeeRequestPriority....


   export const getEmployeeRequestPriority = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/EmployeeRequest/Priority/List`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// add EmployeeRequestPriority....

  export const addEmployeeRequestPriority = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/Priority/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// delete EmployeeRequestPriority....

  export const deleteEmployeeRequestPriority = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/Priority/Delete`,
      {
        headers: await getHeaders(),
        data: params   
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get EmployeeRequestSeverity..

   export const getEmployeeRequestSeverity = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/EmployeeRequest/Severity/List`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add EmployeeRequestSeverity..


  export const addEmployeeRequestSeverity = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/Severity/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete EmployeeRequestSeverity..

   export const deleteEmployeeRequestSeverity = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/Severity/Delete`,
      {
        headers: await getHeaders(),
        data: params  
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get EmployeeRequestStatus..

   export const getEmployeeRequestStatus = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/EmployeeRequest/Status/List`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add EmployeeRequestStatus..

  export const addEmployeeRequestStatus = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/Status/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete EmployeeRequestStatus..


 export const deleteEmployeeRequestStatus = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/Status/Delete`,
      {
        headers: await getHeaders(),
        data: params   
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Add EmployeeRequestSubCategory..

  export const addEmployeeRequestSubCategory = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/SubCategory/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete EmployeeRequestSubCategory..


 export const deleteEmployeeRequestSubCategory = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/SubCategory/Delete`,
      {
        headers: await getHeaders(),
        data: params   
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get EmployeeRequestDefaultAssignment...

   export const getEmployeeRequestDefaultAssignment = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/DefaultAssignment
`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add EmployeeRequestDefaultAssignment...


  export const addEmployeeRequestDefaultAssignment = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/DefaultAssignment/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete EmployeeRequestDefaultAssignment...


export const deleteEmployeeRequestDefaultAssignment = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/DefaultAssignment/Delete`,
      {
        headers: await getHeaders(),
        data: params    
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get EmployeeRequestAccess..
   
       export const getEmployeeRequestAccess = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/RequestAccess
`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add EmployeeRequestAccess..

    export const addEmployeeRequestAccess = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/RequestAccess/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete EmployeeRequestAccess..

export const deleteEmployeeRequestAccess = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/RequestAccess/Delete`,
      {
        headers: await getHeaders(),
        data: params  
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get EmployeeRequestDefaultNotification...


       export const getEmployeeRequestDefaultNotification = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseTicketURL}/Lead/EmployeeRequest/DefaultNotification/Get
`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }



// Add  EmployeeRequestDefaultNotification...


    export const addEmployeeRequestDefaultNotification = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseTicketURL}/Lead/EmployeeRequest/DefaultNotification/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };



// Delete EmployeeRequestDefaultNotification...


export const deleteEmployeeRequestDefaultNotification = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseTicketURL}/Lead/EmployeeRequest/DefaultNotification/Delete`,
      {
        headers: await getHeaders(),
        data: params   
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

